import { Component, Input, OnInit, Output } from '@angular/core';
import { LayoutService } from '@app/layout/layout.service';
import { RecordPageComponent } from '@app/layout/record-page/record-page.component';
import { ApprovalDecisionStructure } from '@app/models/approval-decision-structure';
import { InboxService } from '@app/services/InboxService.service';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-approval-decision-dialog',
  templateUrl: './approval-decision-dialog.component.html',
  styleUrls: ['./approval-decision-dialog.component.less'],
})
export class ApprovalDecisionDialogComponent implements OnInit {
  @Input() wddCode: string;
  @Input() parentName: string;

  approvalDecisions: ApprovalDecisionStructure[];

  global = g;

  static drawerRef: any;

  constructor(
    private inboxService: InboxService,
    private notification: NzNotificationService,
    public layoutService: LayoutService,
    public drawerService: NzDrawerService
  ) {}

  ngOnInit(): void {
    let docEntry = this.wddCode;

    this.layoutService
      .executeQuery(2191, {
        'Documents.DocEntry': docEntry,
      })
      .subscribe((data: ApprovalDecisionStructure[]) => {
        console.log(data);
        this.approvalDecisions = data;
      });
  }

  openDraftDocument(docEntry, approvalDecision: ApprovalDecisionStructure) {
    RecordPageComponent.openRecordPage(this.drawerService, {
      actionType: 'View',
      drawerTitle: 'View Details',
      inDrawer: true,
      moduleId: approvalDecision.ModuleId,
      parentComponent: this,
      recordId: docEntry,
      recordModel: undefined,
      fromDraft:
        approvalDecision.ModuleId != 59 && approvalDecision.IsDraft == 'Y',
    });
  }

  static openTemplate(
    docEntry,
    parentName,
    drawerService: NzDrawerService,
    layoutService: LayoutService
  ): void {
    this.drawerRef = drawerService.create({
      nzTitle: layoutService.translate('Approval(s)'),
      nzContent: ApprovalDecisionDialogComponent,
      nzWrapClassName: 'drawer-size-2x drawer-body-no-padding',
      nzContentParams: {
        wddCode: docEntry,
        parentName: parentName,
      },
    });
  }

  onApprovalSubmit(approvalDecision: ApprovalDecisionStructure) {
    this.inboxService
      .changeApprovalStatus(
        approvalDecision.WddCode,
        approvalDecision.AppStatus,
        approvalDecision.AppRemark
      )
      .subscribe((d: any) => {
        if (d.Has_Error) {
          this.notification.create('error', '', d.Error_Message);
        } else {
          this.notification.create(
            'success',
            'Status changed',
            'Approval Status changed successfuly'
          );

          ApprovalDecisionDialogComponent.drawerRef.close();
          ApprovalDecisionDialogComponent.drawerRef = undefined;
          this.layoutService.triggerRefreshReportResult.emit(this.parentName);
        }
      });
  }
}
